module.exports = __webpack_public_path__ + "static/media/5.8f24bd0a.jpg";